var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vcnSystmList section-main__warp1 flex-valign"},[_c('div',{staticClass:"svnSystem-main flex-auto"},[_c('vcnsystem',{ref:"Vcn",attrs:{"sel":_vm.deviceType}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }